import Abstract from "../../abstract-view/abstract.js";

export default class GalleryContainer extends Abstract {
  constructor(element) {
    super();

    this._element = element;

    this._galleryElement = null;
    this._thumbsElement = null;
  }

  getGalleryElement() {
    if (!this._galleryElement) {
      this._galleryElement = this._element.querySelector(`.product-gallery-container`);
    }

    return this._galleryElement;
  }

  getThumbsElement() {
    if (!this._thumbsElement) {
      this._thumbsElement = this._element.querySelector(`.product-gallery-thumbs-wrapper`);
    }

    return this._thumbsElement;
  }
}
